module.exports = __webpack_public_path__ + "img/img4_6.c5189a28.jpeg";